slot[name="on"],
slot[name="off"] {
    cursor: pointer;
    display: none;
}

:host([on]) {
    slot[name="on"] {
        display: inline-block;
    }
}

:host([off]) {
    slot[name="off"] {
        display: inline-block;
    }
}

:host([error]) {
    slot {
        color: var(--ux-input-error-color);
    }
}
